import React from 'react';

const benefits = [
  {
    number: '01.',
    title: 'Регулярні онлайн-зустрічі.',
    desc: 'Тематичні воркшопи, майстер-класи та обговорення найактуальніших тем для бізнесу.',
    delay: 100,
  },
  {
    number: '02.',
    title: 'Бібліотека знань.',
    desc: 'Доступ до записів попередніх зустрічей, які ти можеш переглядати у зручний для тебе час. Це наш скарб.',
    delay: 200,
  },
  {
    number: '03.',
    title: 'Закритий чат.',
    desc: 'Чат учасниць для обміну ідеями, запитів на допомогу та мотивації.',
    delay: 300,
  },
  {
    number: '04.',
    title: 'Офлайн заходи.',
    desc: 'Неформальні зустрічі для нетворкінгу, зустрічі з топовими підриємцями та експертами, мастермайнди, групові коуч сесії.',
    delay: 400,
  },
  {
    number: '05.',
    title: 'Групові зустрічі з професійними психологами, коучами.',
    desc: 'Ми точно знаємо, що твій внутрішній стан впливає на розвиток твого бізнесу. З турботою про тебе ми влаштовуємо зустрічі, спрямовані на підтримку твого ресурсу.',
    delay: 500,
  },
  {
    number: '06.',
    title: 'Різні пакети участі.',
    desc: 'Тепер ти можеш обрати формат участі, який найкраще відповідає твоїм потребам: від базового доступу до розширених пакетів із додатковими перевагами.',
    delay: 600,
  },
  {
    number: '07.',
    title: 'Підтримка однодумців.',
    desc: 'Тут ти знайдеш тих, хто розуміє тебе як підприємицю, проходить схожий шлях і готовий ділитися досвідом.',
    delay: 700,
  },
  {
    number: '08.',
    title: 'Нетворкінг з підприємцями',
    desc: 'Наші онлайн зустрічі часто називають "на кухні з подругами", усі спікерки та спікери, які приходять до нас відкриті, чесні, готові ділитися з тобою своїми інсайтами та інформацією. Тому під час зустрічі ти можеш задавати свої питання, знайомитися чи навіть відразу генерувати ідеї для спільних колаборацій.',
    delay: 800,
  },
];

export default function Benefits() {
  return (
    <section className="benefits" id="benefits">
      <h2>Що дає підписка на спільноту?</h2>
      <div className="benefits-grid">
        {benefits.map((b, i) => (
          <div className="benefit-card" data-aos="fade-up" data-aos-delay={b.delay} key={i}>
            <span className="number">{b.number}</span>
            <h3>{b.title}</h3>
            <p>{b.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}